/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const DEFAULT_CAROUSEL_OPTS = {
	naturalSlideWidth: 248,
	naturalSlideHeight: 300,
	infinite: true,
	dragEnabled: false,
	isIntrinsicHeight: true,
	// add these properties where this object is used: visibleSlides, step, totalSlides
};
